import { Dayjs } from 'dayjs';
import { useNavigate } from 'react-router-dom';

export function useNavigateToDate() {
  const navigate = useNavigate();
  return (date: Dayjs) => {
    navigate(`/termine/uebersicht/${date.format('YYYY/M')}`, { replace: true });
  };
}
